import { AvailablePlan } from '@/data/services/plan/plan-service-types'
import { PublicPlanItem } from './plan-service-types'

const PLAN_METADATA: Record<string, AvailablePlan> = {
  STARTER: {
    id: 1,
    name: 'Starter',
    color: 'info-900',
    backgroundColor: 'info-100',
    key: 'starter'
  },
  SILVER: {
    id: 2,
    name: 'Silver',
    color: 'grey-900',
    backgroundColor: 'grey-100',
    key: 'silver'
  },
  GOLD: {
    id: 3,
    name: 'Gold',
    color: 'warning-900',
    backgroundColor: 'warning-200',
    key: 'gold'
  },
  SKILL_ONE: {
    id: 4,
    name: 'Skill One',
    color: 'common-white',
    backgroundColor: 'rose-600',
    key: 'skill_one'
  },
  BLACK: {
    id: 5,
    name: 'Black',
    color: 'common-white',
    backgroundColor: 'primary-950',
    key: 'black'
  }
}

// ID do plano "Skill One". Algumas regras de negócio (ex: ocultar o chip "Coberto pelo plano")
// dependem da identidade desse plano específico — derivado do metadata para evitar number mágico.
export const SKILL_ONE_PLAN_ID = PLAN_METADATA.SKILL_ONE.id

// Aceita id como string | number: AvailablePlan usa number, mas account.passPlan (IdNameModel)
// pode trazer string. Coage para number antes de comparar.
export const isSkillOnePlan = (plan: { id: string | number } | null | undefined): boolean =>
  plan != null && Number(plan.id) === SKILL_ONE_PLAN_ID

const normalizeToKey = (name: string): string =>
  name
    .replace(/([a-z])([A-Z])/g, '$1_$2')
    .replace(/[\s-]+/g, '_')
    .toUpperCase()

const PLANS_BY_ID: Record<number, AvailablePlan> = Object.fromEntries(
  Object.values(PLAN_METADATA).map(plan => [plan.id, plan])
)

const PLANS_BY_NAME: Record<string, AvailablePlan> = Object.fromEntries(
  Object.values(PLAN_METADATA).map(plan => [normalizeToKey(plan.name), plan])
)

export const formatAvailablePlans = (items: PublicPlanItem[]): AvailablePlan[] => {
  const plans = items.flatMap(p => {
    const plan = PLANS_BY_NAME[normalizeToKey(p.name)]
    if (plan) {
      return [plan]
    }

    return []
  })

  return plans
}

export const findPlanById = (
  plans: AvailablePlan[],
  id: number | null
): AvailablePlan | undefined => {
  if (!id) return undefined

  const plan = plans.find(p => p.id === id)
  return plan
}

export const findPlanByIdFromMeta = (id: number): AvailablePlan | undefined => {
  const plan = PLANS_BY_ID[id]
  return plan
}

export const findPlanByNameFromMeta = (name: string | null): AvailablePlan | undefined => {
  if (!name) return undefined

  const plan = PLANS_BY_NAME[normalizeToKey(name)]
  return plan
}

export const getAllPlansFromMeta = (): AvailablePlan[] => {
  const plans = Object.values(PLANS_BY_ID).sort((a, b) => a.id - b.id)

  return plans
}

export const findPlanByName = (
  plans: AvailablePlan[],
  name: string | null
): AvailablePlan | undefined => {
  if (!name) return undefined
  const plan = plans.find(p => p.name.toLowerCase() === name.toLowerCase())

  return plan
}

export const findPlanByKey = (plans: AvailablePlan[], key: string): AvailablePlan | undefined => {
  const plan = plans.find(p => p.key.toLowerCase() === key.toLowerCase())

  return plan
}
